import React from 'react';
import { etiquetaMotivoExpres, ESTILO_EXPRES } from '../../constants/tramiteExpres';
import { apellidoNombre } from '../../utils/nombrePersona';
import styles from '../../style/pages/Turnero.module.css';

// "2026-10-05" → "05 oct 2026", sin desfase UTC.
function formatearFecha(iso) {
    if (!iso) return '';
    const [y, m, d] = String(iso).split('-').map(Number);
    const fecha = new Date(y, m - 1, d);
    if (Number.isNaN(fecha.getTime())) return String(iso);
    return fecha.toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' }).replace('.', '');
}

function Fila({ icono, etiqueta, children, ancha = false }) {
    return (
        <div className={`${styles.infoFila} ${ancha ? styles.infoFilaAncha : ''}`}>
            <i className={`bi ${icono}`} style={{ color: ESTILO_EXPRES.text }} />
            <div>
                <span className={styles.infoLabel}>{etiqueta}</span>
                <div className={styles.infoValor} style={ancha ? { whiteSpace: 'pre-wrap' } : undefined}>{children}</div>
            </div>
        </div>
    );
}

/**
 * Vista del detalle de un trámite exprés (V249) dentro de ModalDetalleTurno. No tiene atención,
 * cola ni cambios de estado: muestra quién vino, cuándo, qué dejó o retiró, por qué y quién lo
 * registró.
 *
 * Los exprés anteriores a V249 no tienen los campos separados: su texto quedó en la bitácora
 * (observaciones), que se muestra en lugar de "qué entregó".
 */
function DetalleTramiteExpres({ turno }) {
    const documentacion = turno.expresDocumentacion || turno.observaciones || '';
    const documento = [turno.dni && `DNI ${turno.dni}`, turno.cuil && `CUIL ${turno.cuil}`].filter(Boolean).join(' · ');

    return (
        <>
            <div className={styles.infoLista}>
                <Fila icono="bi-person-fill" etiqueta="Cliente">
                    {apellidoNombre(turno.apellido, turno.nombre) || '-'}
                    {documento && <div className="small text-secondary">{documento}</div>}
                </Fila>
                <Fila icono="bi-calendar-event" etiqueta="Fecha del turno">
                    {formatearFecha(turno.fechaTurno)}{turno.horario ? ` · ${turno.horario}` : ''}
                </Fila>
                <Fila icono="bi-person-badge" etiqueta="Lo atendió">
                    {turno.operadorNombre || 'No registrado'}
                </Fila>
                {turno.idTurnoOrigen != null && (
                    <Fila icono="bi-link-45deg" etiqueta="Origen">
                        Volvió después de una atención de hoy
                    </Fila>
                )}
                {turno.telefonoCliente && (
                    <Fila icono="bi-telephone-fill" etiqueta="Teléfono">
                        {turno.telefonoCliente}
                    </Fila>
                )}
                <Fila icono="bi-folder-symlink" etiqueta="Qué entregó / retiró" ancha>
                    {documentacion || 'No registrado'}
                </Fila>
                <Fila icono="bi-question-circle" etiqueta="Por qué fue exprés" ancha>
                    {etiquetaMotivoExpres(turno.expresMotivo, turno.expresMotivoDetalle) || 'No registrado'}
                </Fila>
                <Fila icono="bi-chat-left-text-fill" etiqueta="Observaciones" ancha>
                    {turno.expresObservaciones || 'Sin observaciones'}
                </Fila>
            </div>
        </>
    );
}

/**
 * Aviso de qué es un trámite exprés. ModalDetalleTurno lo pone al pie de la tarjeta del nombre:
 * en el exprés reemplaza a los chips de estado, que ahí no dicen nada (siempre es Finalizado).
 */
export function AvisoTramiteExpres({ className = '' }) {
    return (
        <div
            className={`${styles.callout} ${className}`.trim()}
            style={{ background: ESTILO_EXPRES.bg, borderColor: ESTILO_EXPRES.border }}
        >
            <div className={styles.calloutIcono} style={{ background: ESTILO_EXPRES.riel }}>
                <i className="bi bi-lightning-charge-fill" />
            </div>
            <div className={styles.calloutTexto}>
                <div className={styles.calloutTitulo} style={{ color: ESTILO_EXPRES.text }}>
                    Trámite exprés
                </div>
                <div className={styles.calloutDetalle}>
                    Solo entregó o retiró documentación: se registró y finalizó en el acto. No cuenta en las estadísticas.
                </div>
            </div>
        </div>
    );
}

export default DetalleTramiteExpres;
